export const phoneDigits = (value) => (value || "").replace(/\D/g, "");

export const phoneMask = (value) =>
  phoneDigits(value).length > 10 ? "(99) 99999-9999" : "(99) 9999-99999";

export const formatPhone = (value) => {
  const digits = phoneDigits(value);
  if (digits.length < 10) return value;
  const split = digits.length === 10 ? 6 : 7;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, split)}-${digits.slice(split, 11)}`;
};
